import React, { useState } from 'react'
import {
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  MenuItem
} from '@mui/material'
import { useTranslation } from 'react-i18next'

import { reset } from 'store/actions/pipeline'

const LS_RESET = 'dontShowCheckedReset'

const ResetDialog = ({ handleSubmit, handleClose }) => {
  const { i18n } = useTranslation()
  const t = i18n.getResourceBundle(i18n.language)

  const [skipNextTime, setSkipNextTime] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  return (
    <Dialog className="Profile-gift-analysis-dialog" open={true} onClose={handleClose}>
      <DialogTitle>{t.cards.resetTitle}</DialogTitle>
      <DialogContent>
        <p>{t.cards.resetConfirm}</p>
        <FormControlLabel
          control={
            <Checkbox checked={skipNextTime} onCheck={() => setSkipNextTime(!skipNextTime)} />
          }
          label={t.cards.noShow}
        />
      </DialogContent>
      <DialogActions>
        {!isLoading && (
          <Button onClick={handleClose} disabled={isLoading} variant="text">
            {t.global.cancel}
          </Button>
        )}
        <Button
          onClick={async () => {
            setIsLoading(true)
            await handleSubmit(skipNextTime)
            handleClose()
          }}
          disabled={isLoading}
        >
          {!isLoading ? t.cards.reset : <CircularProgress size={20} />}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

const ResetCardAction = ({ opportunityId, setShowDialog, loadData, dispatch }) => {
  const { i18n } = useTranslation()
  const t = i18n.getResourceBundle(i18n.language)

  const handleSubmit = async skipNextTime => {
    if (skipNextTime) localStorage.setItem(LS_RESET, true)

    await dispatch(reset(opportunityId))
    await dispatch(loadData())
  }

  const handleReset = () => {
    const skip = localStorage[LS_RESET] === 'true'

    if (skip) {
      setShowDialog(false)
      return handleSubmit()
    }

    setShowDialog(
      <ResetDialog handleSubmit={handleSubmit} handleClose={() => setShowDialog(false)} />
    )
  }

  return (
    <MenuItem className="Material-cards__expanded-actions-item" onClick={handleReset}>
      {t.cards.reset}
    </MenuItem>
  )
}

export default ResetCardAction
